// D3 v3 browser environment polyfill
// Fix for "Cannot read properties of undefined (reading 'document')"

(function() {
  'use strict';
  
  // The root cause: D3 v3 UMD tries to access `this.document` 
  // but `this` is undefined in strict mode / module context
  
  // Set up the global object to have the properties D3 expects
  var globalObj = (function() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof global !== 'undefined') return global;
    if (typeof window !== 'undefined') return window;
    if (typeof self !== 'undefined') return self;
    throw new Error('Unable to locate global object');
  })();
  
  // Ensure the global object has browser DOM properties
  if (typeof document !== 'undefined' && !globalObj.document) {
    try {
      Object.defineProperty(globalObj, 'document', {
        value: document,
        writable: false,
        configurable: true
      });
    } catch (e) {
      globalObj.document = document;
    }
  }
  
  if (typeof window !== 'undefined' && !globalObj.window) {
    try {
      Object.defineProperty(globalObj, 'window', {
        value: window, 
        writable: false,
        configurable: true
      });
    } catch (e) {
      globalObj.window = window;
    }
  }
  
  if (typeof navigator !== 'undefined' && !globalObj.navigator) {
    try {
      Object.defineProperty(globalObj, 'navigator', {
        value: navigator,
        writable: false, 
        configurable: true
      });
    } catch (e) {
      globalObj.navigator = navigator;
    }
  }

})();